import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { SailDirection } from 'src/app/front-user/shared/models/sail-direction.model';
import { GenericLookup } from './general.model';

export class CrewDetailsDTO {
    Id: string;
    CrewChangeRequestId: string;
    Name: string;
    PassportNumber: string;
    AttachmentURL: string;
    ChangeDirection: number;
    AddedBy: string;
    IsChanged?: boolean;
    FinalNotes?: string;
    // CreationDate: Date;
    // ModifiedDate: Date;
    // CreatedBy: string;
    // ModifiedBy: string;
    IsDeleted: boolean;
};

export class CrewChangeRequestDTO {
    RequestorEmail: string;
    RequestorId: string;
    StatusId: number;
    Id: string;
    VesselName: string;
    VesselTypeId: number; 
    VesselTypeOther: string; 
    IMONO: string; 
    NationalityId: number; 
    FromPort: string;
    ToPort: string; 
    SailDirectionId: number; 
    TransitDate: Date;
    ServiceTypeId: number; 
    ServiceLocationId: number; 
    IsCompleted?: boolean;
    FinalNotes?: string;
    ActualFees?: number; 
    ActualDate?: Date; 
    ActualLocation?: number;
    ActualServiceType?: number;
    ReviewerDecision?: number;
    ReviewerNotes?: string;
    ApprovalDecision?: number;
    ApprovalNotes?: string;
    ApprovalTotalFees?: number;
    AgentDecision?: number;
    AgentNotes?: string; 
    IsPostedToSCA?: boolean;
    InvoiceURL?: string;
    // CreationDate: Date;
    // ModifiedDate: Date;
    // CreatedBy: string;
    // ModifiedBy: string;
    BaseRequest: BaseRequest;
    VesselType: GenericLookup = new GenericLookup()
    Nationality: GenericLookup = new GenericLookup();
    SailDirection: SailDirection;
    CrewDetailsDTO: CrewDetailsDTO[];
};

export class CrewChangeAdminDTO {
    RequestorEmail: string;
    RequestorId: string;
    StatusId: number;
    Id: string;
    AdminEmail: string;
    IsCompleted?: boolean;
    FinalNotes?: string;
    ActualFees?: number; 
    ActualDate?: Date; 
    ActualLocation?: number;
    ReviewerDecision?: number;
    ReviewerNotes?: string;
    ApprovalDecision?: number;
    ApprovalNotes?: string;
    ApprovalTotalFees?: number;
    AgentDecision?: number;
    AgentNotes?: string; 
    CrewDetails: CrewDetailsDTO[];
};

export class RelatedTransitRequestsDTO {
    Id: string;
    IMONo: string;
    RequestNumber: string;
    Status: string;
    serviceName: string;
}